const initialState = () => ({
  notifications: [],
  actionAssignedToLine: false,
  actionSendTemplates: false,
})

export default initialState
